import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from 'helper/className';

const ToggleMenu = ({ className }) => (
  <div id="hide-menu" className={classNames(className, ToggleMenu.className)}>
    <a className="menu-link" href="#" onClick={ToggleMenu.toggle} title="Collapse Menu">
      <i className="fa fa-reorder"/>
    </a>
  </div>
);

ToggleMenu.className = 'toggle-menu';
ToggleMenu.getClassName = getClassNameGenerator(ToggleMenu.className);

ToggleMenu.propTypes = {
  className: PropTypes.string
};

ToggleMenu.defaultProps = {

};

ToggleMenu.open = () => {
  const $body = $('body');
  const $html = $('html');
  $html.addClass('hidden-menu-mobile-lock');
  $body.addClass('hidden-menu');
  $body.removeClass('minified');
};

ToggleMenu.close = () => {
  const $body = $('body');
  const $html = $('html');
  $html.removeClass('hidden-menu-mobile-lock');
  $body.removeClass('hidden-menu');
  $body.removeClass('minified');
};

ToggleMenu.toggle = (e) => {
  const $body = $('body');
  if ($body.hasClass('hidden-menu')) {
    ToggleMenu.close(e);
  } else {
    ToggleMenu.open(e);
  }
  e.preventDefault();
};

ToggleMenu.closeIfMinified = () => {
  const $body = $('body');
  if ($body.hasClass('hidden-menu')) {
    ToggleMenu.close();
  }
};

export default ToggleMenu;
